import type { BellItem } from './bellItems';
import styles from './NoticeCard.module.css';

export interface NoticeCardProps {
  readonly item: BellItem;
  /** `float`: the warning on entry, with a shadow; `list`: an item of the bell. */
  readonly variant: 'float' | 'list';
  readonly onAction: (item: BellItem) => void;
  readonly onClose: (item: BellItem) => void;
  /** Said by the × to a screen reader: "Fechar aviso" in the float, "Excluir" in the bell. */
  readonly closeLabel: string;
  readonly actionPending?: boolean | undefined;
}

/**
 * "Notificação · inatividade": one colour per stage — âmbar 30 dias, vermelho 7 dias, grafite no
 * bloqueio, verde na reativação — with a 4px bar on the leading edge, the stage in small caps, the
 * title, the sentence, the action and a ×. The same card is the floating warning on entry and an
 * item of the bell; only the shadow and what the × means change. It draws a `BellItem`, so the
 * boleto reminders wear the same four colours.
 */
export function NoticeCard({
  item,
  variant,
  onAction,
  onClose,
  closeLabel,
  actionPending = false,
}: NoticeCardProps) {
  return (
    <article
      className={styles.card}
      data-tone={item.tone}
      data-variant={variant}
      aria-label={item.title}
    >
      <span className={styles.icon} aria-hidden="true">
        {item.glyph}
      </span>
      <div className={styles.text}>
        <p className={styles.label}>{item.label}</p>
        <p className={styles.title}>{item.title}</p>
        <p className={styles.description}>{item.description}</p>
        {item.actionLabel === null || item.action === null ? null : (
          <button
            type="button"
            className={styles.action}
            disabled={actionPending}
            onClick={() => {
              onAction(item);
            }}
          >
            {actionPending ? 'Enviando…' : `${item.actionLabel} →`}
          </button>
        )}
      </div>
      <button
        type="button"
        className={styles.close}
        aria-label={`${closeLabel}: ${item.title}`}
        onClick={() => {
          onClose(item);
        }}
      >
        <span aria-hidden="true">×</span>
      </button>
    </article>
  );
}
